let t = -1;
const e = () => String(++t);
export {
  e as useId
};
